module.exports = __webpack_public_path__ + "img/street-light.30954133.svg";